import { ReactComponent as CloseFilled } from '../assets/icons/close-filled.svg'
import { ReactComponent as VisibleIcon } from '../assets/icons/visible.svg'
import { ReactComponent as InvisibleIcon } from '../assets/icons/invisible.svg'
import { ReactComponent as Check } from '../assets/icons/checkmark.svg'
import { useForm } from 'react-hook-form'
import { useState } from 'react'

export default function ResetPasswordNew() {
  const [showPassword, setShowPassword] = useState(false)
  const [capsLockOn, setCapsLockOn] = useState(false)
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm()
  console.log(watch())
  const onSubmit = async (data) => {
    console.log(data)
  }
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className='min-w-[340px]'>
        <div className='mb-36 flex flex-col gap-12'>
          <p className='text-center text-title2-bold text-label-default'>비밀번호 재설정</p>
          <p className='text-center text-body2-long-regular text-label-sub'>
            새롭게 이용할 비밀번호를 입력해주세요.
          </p>
        </div>
        <div className='mb-32 flex w-full flex-col items-start gap-16'>
          <div className='flex w-full flex-col gap-8'>
            <div className='flex w-full flex-col gap-4'>
              <div className='flex w-full justify-between'>
                <p className='text-body1-semibold text-label-default'>새 비밀번호</p>
                {capsLockOn && (
                  <p className='rounded-4 bg-background-alternative px-8 py-4 text-caption-regular text-label-info'>
                    Caps Lock이 켜져있습니다
                  </p>
                )}
              </div>
              <div className='relative w-full'>
                <input
                  {...register('password', {
                    required: '비밀번호를 입력해주세요',
                  })}
                  type={showPassword ? 'text' : 'password'}
                  onClick={(e) => setCapsLockOn(e.getModifierState('CapsLock'))}
                  onKeyUp={(e) => setCapsLockOn(e.getModifierState('CapsLock'))}
                  className={`${errors.password ? 'border-status-negative hover:border-status-negative focus:border-status-negative' : ''} input_default w-full`}
                  placeholder='비밀번호를 입력하세요'
                />
                <span className='text-caption-regular text-status-negative'>
                  {errors?.password?.message}
                </span>
                {watch('password') && (
                  <div className='absolute right-16 top-16 flex gap-16'>
                    <button
                      type='button'
                      onClick={() => setValue('password', '')}
                      className='cursor-pointer'
                    >
                      <CloseFilled />
                    </button>
                    <button
                      type='button'
                      onClick={() => setShowPassword((prev) => !prev)}
                      className='cursor-pointer'
                    >
                      {showPassword ? <InvisibleIcon /> : <VisibleIcon />}
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className='flex flex-col gap-2'>
              <div className='flex items-center gap-4 fill-label-info'>
                <Check className='w-18 h-18' />
                <p className='text-caption-regular text-label-info'>
                  최소 10자 이상 최대 30자 이하
                </p>
              </div>
              <div className='flex items-center gap-4 fill-label-info'>
                <Check className='w-18 h-18' />
                <p className='text-caption-regular text-label-info'>
                  영문자, 숫자, 특수문자 중 2종류 이상 조합
                </p>
              </div>
            </div>
          </div>
          <div className='flex w-full flex-col gap-4'>
            <p className='text-body1-semibold text-label-default'>새 비밀번호 확인</p>
            <div className='relative w-full'>
              <input
                {...register('check', {
                  required: '비밀번호가 일치하지 않습니다. 다시 한번 확인해주세요.',
                })}
                type={showPassword ? 'text' : 'password'}
                className={`${errors.check ? 'border-status-negative hover:border-status-negative focus:border-status-negative' : ''} input_default w-full`}
                placeholder='비밀번호를 입력하세요'
              />
              <span className='text-caption-regular text-status-negative'>
                {errors?.check?.message}
              </span>
              {watch('check') && (
                <div className='absolute right-16 top-16 flex gap-16'>
                  <button
                    type='button'
                    onClick={() => setValue('check', '')}
                    className='cursor-pointer'
                  >
                    <CloseFilled />
                  </button>
                  <button
                    type='button'
                    onClick={() => setShowPassword((prev) => !prev)}
                    className='cursor-pointer'
                  >
                    {showPassword ? <InvisibleIcon /> : <VisibleIcon />}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        <button type='submit' className='button_solid_primary_lg mb-16 w-full'>
          비밀번호 재설정
        </button>
      </div>
    </form>
  )
}
